/**
 * @module websocket.event.handlers.bookings.booking-list-updated
 */
import { store } from '../../../../state/store'
import { setBookingListUpdated } from '../../../../state/websocket.slice'

export default function handleBookingListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setBookingListUpdated(data))
  }
} 